const EXERCISE_INCIDENT_TYPE = 'Exercise';

const EXERCISE_NAME_PREFIX = 'Exercise Exercise Exercise ';

/**
 * If `Exercise` is in incident types, store/display name with the exercise
 * prefix once. If not, strips one leading prefix so toggling Exercise off does
 * not leave a stale prefix.
 */
export function applyExerciseIncidentName(
  name: string,
  incidentTypes: string[] | undefined | null
): string {
  const hasExercise =
    incidentTypes?.some((t) => String(t).trim() === EXERCISE_INCIDENT_TYPE) ??
    false;
  const base = name.startsWith(EXERCISE_NAME_PREFIX)
    ? name.slice(EXERCISE_NAME_PREFIX.length)
    : name;
  const trimmed = base.trim();
  if (hasExercise) {
    return `${EXERCISE_NAME_PREFIX}${trimmed}`;
  }
  return trimmed;
}
